import {Directive} from '@angular/core';
import {FormControl, NG_VALIDATORS} from '@angular/forms';

export function requiredFieldValidator(control: FormControl) {
  const  field = control.value;
  if (field == null || field.trim() === '') {
    return {
      invalid: true
    };
  }
  return null;
}

@Directive({
  selector: '[requiredFieldValidator][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useValue: requiredFieldValidator, multi: true}
  ]
})
export class RequiredFieldValidatorDirective {

  constructor() {
  }

}
